// A DID's self-asserted display name, read from its current DID document
// (GET /did/{did}). Only a did:webvh has a document that can carry one.
import { useEffect, useState } from "react";
import { api } from "../api/client";
import { displayNameOf } from "./displayName";

const cache = new Map<string, Promise<string | null>>();

export function fetchDidName(did: string): Promise<string | null> {
  if (!did.startsWith("did:webvh:")) return Promise.resolve(null);
  if (!cache.has(did))
    cache.set(did, api.GET("/did/{did}", { params: { path: { did } } })
      .then((r) => displayNameOf(r.data?.didDocument as any), () => null));
  return cache.get(did)!;
}

export const forgetDidName = (did: string) => cache.delete(did);

export function useDidName(did: string | undefined, version = 0): string | null {
  const [name, setName] = useState<string | null>(null);
  useEffect(() => {
    let live = true;
    setName(null);
    if (did) fetchDidName(did).then((n) => live && setName(n));
    return () => { live = false; };
  }, [did, version]);
  return name;
}
